const getValueByParameterCaseInsensitive = (object, key) => {
  return object[
    Object.keys(object).filter(function(k) {
      return k.toLowerCase() === key.toLowerCase();
    })[0]
  ];
};

export { getValueByParameterCaseInsensitive };
